import { Controller } from "@hotwired/stimulus"
import { submitGetFormTrimmed } from "../utils/get_form_submit"

// Submits a form after the user stops typing (debounced). Uses the same GET empty-field stripping as form-submit.
export default class extends Controller {
  static values = {
    debounce: { type: Number, default: 300 }
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    this.cancel()
  }

  search() {
    this.cancel()
    this.timeout = setTimeout(() => {
      this.submit()
    }, this.debounceValue)
  }

  submit() {
    const form = this.resolveForm(this.element)
    if (!form) return
    submitGetFormTrimmed(form)
  }

  resolveForm(el) {
    if (el instanceof HTMLFormElement) return el
    if ("form" in el && el.form instanceof HTMLFormElement) return el.form
    if (el instanceof Element) return el.closest("form")
    return null
  }

  cancel() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }
}
